(() => {
  const classifyLegacyProductCardImages = (root = document) => {
    const images = root.querySelectorAll?.('.lohas-rich img[alt=""], .lohas-rich img:not([alt])') || [];

    images.forEach((image) => {
      const card = image.closest('.product-inner, .pr_grid_item');
      if (!card) return;

      if (image.closest('.back-img, .hover_img')) {
        image.alt = '';
        image.setAttribute('role', 'presentation');
        return;
      }

      const title = card.querySelector('.product-title a, .product-info__title a, [class*="product-title"] a');
      const label = title?.textContent?.replace(/\s+/g, ' ').trim();
      if (!label) return;

      image.alt = label;
      image.removeAttribute('role');
    });
  };

  const addMerchantWidgetName = () => {
    const frame = document.getElementById('merchantwidgetiframe');
    if (!frame) return false;

    const isEnglish = document.documentElement.lang.toLowerCase().startsWith('en');
    const label = isEnglish ? 'Google customer reviews' : 'Google 顧客評價';

    if (!frame.title) frame.title = label;
    if (!frame.getAttribute('aria-label')) frame.setAttribute('aria-label', label);
    return true;
  };

  const start = () => {
    classifyLegacyProductCardImages();
    addMerchantWidgetName();

    const observer = new MutationObserver((mutations) => {
      addMerchantWidgetName();
      mutations.forEach(({ addedNodes }) => {
        addedNodes.forEach((node) => {
          if (node.nodeType === Node.ELEMENT_NODE) classifyLegacyProductCardImages(node);
        });
      });
    });

    observer.observe(document.body, { childList: true, subtree: true });
    window.setTimeout(() => observer.disconnect(), 60000);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
